module.exports = __webpack_public_path__ + "static/media/How can I link documents with Visa types.4a673e08.png";